﻿import { createOverlayBG, removeOverlayBG, handleMenuResize, setBodyScrollClass } from "../../../../Fundraising.UI.Shared/Modules/util";
import { init as initNavigation } from './navigation.js';


(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Storefront = {};


    const setMenuTrigger = () => {
        $(document).on("click", ".navbar-toggler", function (e) {
            const $body = $("body");
            const navIsOpen = !$(this).hasClass("collapsed");
            console.log(navIsOpen);
            if(navIsOpen) {
                $body.addClass("nav-open");
                createOverlayBG("menu-background-shadow");
            } else { 
                $body.removeClass("nav-open");
                removeOverlayBG();
            }
        });
    }

    function setCodeValidation() {

        $(document).on("submit", "#code form", function (e) {
            var form = $(this);
            form.find("input[type=submit]").prop("disabled", true);
            // prevent the user from hitting ENTER on a field to submit again
            form.find("input").attr("readonly", true);
            document.body.style.cursor = "wait";

        });
    }

    function checkReturnType() {
        var status = $("#ReturnType").val();
        var returnURL = $("#ReturnUrl").val();
        var tmpTarget = "#find-school-overlay";
        var findSchoolModalTitle = $("#find-school-overlay-title").val();
        var $form = $("#code #form0");

        switch (status) {
            case "CampaignParticipant":
                window.location = returnURL;
                break;
            case "Organization":
                M2.Modal.create('find-school-overlay', findSchoolModalTitle, returnURL, 'modal-md');
                $form.find("input[type=submit]").prop("disabled", false);
                $form.find("input").attr("readonly", false);
                document.body.style.cursor = "default";
                break;
            default:
                $form.find("input[type=submit]").prop("disabled", false);
                $form.find("input").attr("readonly", false);
                document.body.style.cursor = "default";
                break;
        }
    }

    // IS element Present

    function exists(elem) {
        if (elem.length > 0) return true;
    }

    // Success Message

    function successMsg(target) {
        if (typeof target === "undefined") target = ".message-area";
        $(target).fadeIn().delay(1800).fadeOut(500);
    }

    // Set Filters 

    function setFilters() {
        $(".filters select").change(function (e) {
            $("#listing-form").submit();
        });
    }

    // Set Thermometer

    function setProgressBar() {

        var rawValue = $(".goal-thermometer").attr("data-val");
        // If it's a string remove the commas
        if (typeof rawValue === 'string') {
            if (rawValue.indexOf(',') > -1) {
                rawValue = rawValue.replace(/,\s?/g, "");
            }
        }
        var value = parseInt(rawValue);
        var maxValue = 150;

        $(".goal-thermometer").progressbar({
            value: value,
            max: maxValue
        });
    }

    // Set Signle to Multi

    function setSingleToMulti() {
        $(".single-to-multi").click(function (e) {
            e.preventDefault();

            $("#single-multi-form input").each(function () {
                $(this).val($("#single-form [name='" + $(this).attr('name') + "']").val());
            });

            $("#single-multi-form").submit();
        });
    }

    /* Search */

    function searchStore() {
        function split(val) {
            return val.split(/,\s*/);
        }
        $(".search").bind("keydown", function (event) {
            if (event.keyCode === $.ui.keyCode.TAB &&
                $(this).data("ui-autocomplete").menu.active) {
                event.preventDefault();
            }
        }).autocomplete({
            source: function (request, response) {
                const url = $("#search-autocomplete-url").val();
                $.getJSON(url + '?query=' + request.term, function (data) {
                    response($.map(data, function (item) {
                        return {
                            label: item,
                            value: item
                        };
                    }));
                });
            },
            appendTo: ".search-container",
            select: function (event, ui) {
                // put selected value in the input
                $(this).val(ui.item.value);
                // submit the closest form
                $(this).closest("form").submit();
                // prevent jQuery UI from doing anything else
                return false;
            }
        });
    }

    /* Mobile Tester */

    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };

    function setSpecialOverlays() {
        $(".is-gift-view-modal").one("click", function (e) {
            var modalTitle = $(this).data('modal-title');
            var modalContent = $(this).data('modal-content');
            var modalAvailabilityUrl = $(this).data('url-overlay-view');
            const token = $(this).closest("form").find("input[name='__RequestVerificationToken']").val();
            M2.Modal.create('gift', modalTitle, modalContent, null, true);
            setModalAvailability(modalAvailabilityUrl, token);
        });

        $(".renewal-view-modal").one("click", function () {
            var modalTitle = $(this).data('modal-title');
            var modalContent = $(this).data('modal-content');
            var modalAvailabilityUrl = $(this).data('url-overlay-view');
            const token = $(this).closest("form").find("input[name='__RequestVerificationToken']").val();
            M2.Modal.create('renewal', modalTitle, modalContent, null, true);
            setModalAvailability(modalAvailabilityUrl, token);
        });
    }

    // Check Modal Overlay Availability

    function setModalAvailability(url, token) {
        $.ajax({
            url: url,
            method: 'POST',
            data: {
                '__RequestVerificationToken': token
            },
            error: function (jqXHR, textStatus, errorMessage) {
                console.log("error: " + errorMessage); 
            }
        });
    }

    function setCartTools() {
        // Cart Widget 
        $(document).on("click", ".cart-trigger a", function(e) {
            if ($("body").hasClass("nav-open")) return;
            e.preventDefault();
            if ($(".cart-contents").css("display") === "none") {
                $(this).addClass("open");
                $(".cart-contents").slideDown();
                window.setTimeout(() => {
                    $("body").addClass("nav-dropdown-open");
                }, 100);
            } else {
                $(".cart-contents").slideUp('slow', function () {
                    $(".cart-trigger a").removeClass("open");
                    $("body").removeClass("nav-dropdown-open");
                });
            }
        });
    }

    function setVideoHero() {
        var $participantHeader = $('#participant-header');
        var $sliderContent = $('.participant-header-slider');
        var isSliderOpen = $participantHeader.hasClass('open') ? true : false;
        if (isSliderOpen) $sliderContent.addClass('show');

        $(document).on('click', '.learn-trigger', function () {
            if (isSliderOpen) {
                $participantHeader.removeClass('open').addClass('closed');
                M2.Util.stopMediaPlayer();
            } else {
                $participantHeader.addClass('open').removeClass('closed');
            }
        });
    }

    function setSearchSchool() {
        // Search School
        if (exists($("#ReturnType"))) {
            if ($("#ReturnType").val() !== "") checkReturnType();
        }
    }

    function setEligibleProductsNotice() {
        var minimumQuantityRemaining = parseInt($('#ShippingFeeMinimumQuantityRemaining').val());
        var $productPromoAlert = $('.shipping-fee.one-away');

        $(document).on('keyup', '.promo-eligible input#Quantity', function (e) {
            var qty = $(this).val();
            if (!isNaN(qty)) {
                qty = parseInt(qty);
                if (qty >= minimumQuantityRemaining) $productPromoAlert.removeClass('hidden');
                else $productPromoAlert.addClass('hidden');
            }
        });
    }

    // Update Cart

    function setUpdateCart() {
        $(document).on('click', '.update-totals a', function (e) {
            e.preventDefault();
            const $button = $(this);
            const $form = $button.closest("form");
            const cartPostUrl = $form.attr("action");
            const $formFields = $form.find(".data.cart input");
            const token = $form.find("input[name='__RequestVerificationToken']").val();
            const $cartContainer = $("#view-cart");
            const data = {
                '__RequestVerificationToken': token
            }
            $formFields.each(function () {
                const $field = $(this);
                const name = $field.attr("name");
                const value = $field.val();
                data[name] = value;
            });
            updateCart(cartPostUrl, data).done((data) => {
                $cartContainer.html(data);
                if (M2.SpecialOffer) {
                    M2.SpecialOffer.initClaimPaidOffer();
                }
                M2.Storefront.viewCartOnSuccess();
            });
        });
    }

    const updateCart = (url, data = {}) => {
        return $.ajax({
            url: url,
            method: "POST",
            data: data
        });
    }


    function setSearchParticipantTools() {
        $(document).on('click', '.support-choice', function (e) {
            var $choice = $(this);
            var $radioButton = $choice.find('input[type=radio]');
      
            $('.support-choice').removeClass('active');
            $choice.addClass('active');
            $radioButton.prop("checked", true);
            enableSubmit($('.find-school-results-overlay input[type=submit]'));

            var isParticipant = $choice.hasClass('support-participant') ? true : false;
            if (!isParticipant) {
                $('.support-participant input[type=text]').val('');
            }
        });
    }

    function enableSubmit($btn) {
        $btn.removeClass('disabled').attr('disabled', false);
    }

    function disableSubmit($btn) {
        $btn.addClass('disabled').attr('disabled', true);
    }

    const setSearchToggle = () => {
        const searchToggle = document.querySelector('#searchNavDropdown');
        if (!searchToggle) return;
        
        searchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector('.search-container').classList.toggle('show');
        });
    }
   
    M2.Storefront = {
        config: {
            name: "M2 Store"
        },
        init: function () {
            initNavigation();
            setCartTools();
            setVideoHero();
            setSearchSchool();
            setCodeValidation();
            setFilters();
            setSingleToMulti();
            searchStore();
            setSpecialOverlays();
            setEligibleProductsNotice();
            setUpdateCart();
            setProgressBar();
            setSearchParticipantTools();
            setMenuTrigger();
            handleMenuResize();
            setBodyScrollClass();
            setSearchToggle();
        },
        codeOnSuccess: function (result) {
            checkReturnType();
            $.validator.unobtrusive.parse($("#code"));
        },
        listingOnSuccess: function (result) {
            setFilters();
        },
        viewCartOnSuccess: function (result) {
            //setGiftCard();
        },
        addPromoOnBegin: function () {
            M2.Util.displayLoad("#shopping-cart");
        },
        nameOnSuccess: function (result) {
            $.validator.unobtrusive.parse($("#name"));
            var status = $("#ReturnType").val();
            var returnURL = $("#ReturnUrl").val();
            switch (status) {
                case "Success":
                    parent.window.location = returnURL;
                    break;
                default:
                    // Do nothing
                    break;
            }
        },
    };
})(jQuery);

$(function () {
    M2.Storefront.init();
});